import React from "react";
import { FlexContainer, Text, Button } from "../../design";
import { SWIREPAY_URL } from "../../appconstants";
import { Col } from "react-awesome-styled-grid";
import UPIIcon from "../../assets/imgs/upierror.svg";

type Props = {
    heading: string,
    body: string,
    url: string,
    btnText: string
}

const ErrorPage = (props: Props) => {
    return (
        <FlexContainer
            flexDirection="column"
            justifyContent="center"
            alignContent="center"
            className="w-100"
        >
            <Col style={{ width: "inherit" }} xs={8} sm={4} md={4} lg={6} xl={5}>
                <FlexContainer
                    display="block"
                    marginTop="5rem"
                    borderRadius="10px"
                    boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    justifyContent="center"
                    alignContent="center"
                    paddingTop="3rem"
                    paddingRight=".5rem"
                    paddingBottom="3rem"
                    paddingLeft=".5rem"
                    backgroundColor="white"
                    className="text-center"
                >
                    {
                        props.btnText ? (
                            <img src={UPIIcon} alt='UPI-Error' />
                        ) : (
                            <Text
                                fontSize="20px"
                                fontWeight="bold"
                                textAlign="center"
                                color="#ff1e1e"
                            >
                                {props.heading || '!Oops'}
                            </Text>
                        )
                    }

                    <br />
                    <Text
                        fontSize="14px"
                        textAlign="center"
                        color="#000000"
                        paddingRight="3rem"
                        paddingBottom=".5rem"
                        paddingLeft="3rem"
                        whiteSpace="break-spaces"
                    >
                        {props.body}
                    </Text>
                    <br />
                    <Button type={props.btnText ? 'danger' : 'secondary'}
                        border={props.btnText ? '2px solid #ff1e1e !important' : '2px solid #40A9FF !important'}
                        color={props.btnText ? '#fffff !important' : '#40A9FF !important'}
                        paddingRight="1.5rem"
                        paddingTop={props.btnText ? '.6rem' : '.4rem'}
                        paddingBottom={props.btnText ? '.6rem' : '.4rem'}
                        borderRadius="50px"
                        paddingLeft="1.5rem"
                        width={props.btnText ? '60%' : ''}
                        onClick={() => window.location = props.url || SWIREPAY_URL}
                    >
                        {props.btnText ? props.btnText : 'Go Back'}
                    </Button>
                </FlexContainer>
            </Col>
        </FlexContainer>
    )
};

export default ErrorPage;
